import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPaperRed = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 200 164"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#C03221"
      d="M200 0H58.253S32.719 19.613 32.719 67.298c0 41.007 19.364 96.607 12.094 119.367C39.33 203.838 12.743 206.788 0 207.196h134.92s44.371 2.236 51.641-20.531c7.27-22.768-12.095-78.36-12.095-119.375C174.466 19.582 200 0 200 0"
    />
    <path
      fill="#fff"
      d="M200 0H58.253S32.719 19.613 32.719 67.298c0 41.007 19.364 96.607 12.094 119.367C39.33 203.838 12.743 206.788 0 207.196h134.92s44.371 2.236 51.641-20.531c7.27-22.768-12.095-78.36-12.095-119.375C174.466 19.582 200 0 200 0"
      opacity={0.7}
    />
    <g fill="#C03221" opacity={0.8}>
      <path
        d="M161.441 50.289H48.077c3.207-20.979 11.85-33.186 16.618-38.521h109.31c-5.36 9.336-10.42 22.053-12.564 38.52"
        opacity={0.8}
      />
      <path
        d="M160.491 61.414H46.967a101 101 0 0 1 .414-5.547h113.458a118 118 0 0 0-.348 5.547M82.564 72.53H46.929a165 165 0 0 1-.103-5.233v-.306H82.47v.299c0 1.733.028 3.483.094 5.24M161.168 83.647H47.728a145 145 0 0 1-.479-5.539h113.486q.17 2.754.433 5.54M162.419 94.748H49.074a296 296 0 0 1-.734-5.546H161.78c.16 1.867.395 3.718.64 5.546M164.055 105.889H50.805c-.311-1.852-.603-3.703-.885-5.539h113.289q.394 2.769.846 5.539M165.927 117.006H52.685q-.49-2.778-.94-5.539h113.232c.31 1.844.63 3.679.95 5.539M167.93 128.13H54.726c-.179-1.012-.367-2.039-.555-3.067l-.451-2.479h113.204c.338 1.851.668 3.703 1.006 5.546M56.7 139.247q-.47-2.746-.94-5.539h113.186c.329 1.852.668 3.696.987 5.539zM58.497 150.364a380 380 0 0 0-.856-5.539h94.423c.32 1.868.621 3.719.941 5.539zM59.889 161.489q-.273-2.715-.62-5.547h113.345c.253 1.899.489 3.75.686 5.547z"
        opacity={0.3}
      />
    </g>
  </svg>
);
export default SvgPaperRed;
